import { render, staticRenderFns } from "./RenaperConfirmar.vue?vue&type=template&id=4f116320&scoped=true"
import script from "./RenaperConfirmar.vue?vue&type=script&lang=js"
export * from "./RenaperConfirmar.vue?vue&type=script&lang=js"
import style0 from "./RenaperConfirmar.vue?vue&type=style&index=0&id=4f116320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f116320",
  null
  
)

export default component.exports